module.exports = __webpack_public_path__ + "img/modal_cedula_c2024.1a4816d0.jpeg";